import {ID, Resource} from 'simpli-web-sdk'
import DeliveryAuditResponseSchema from '@/schema/DeliveryAuditResponse.schema'

export default class DeliveryAuditResponse extends Resource {
  readonly $name: string = 'DeliveryAuditResponse'
  readonly $endpoint: string = '/user/indicador/auditoria-por-geoposicionamento'

    get $id() {
        return this.id
    }
    set $id(val: ID) {
        this.id = val
    }

    get $schema() {
      return DeliveryAuditResponseSchema(this)
    }

    id: ID = 0
    entregaNaoInformado: number | null = null
    entregaNaoConforme: number | null = null
    entregaConforme: number | null = null
    checkinConforme: number | null = null
    checkinNaoConforme: number | null = null
    checkinNaoInformado: number | null = null
    documento: string | null = null
    nome = ''
}
